export default __webpack_public_path__ + "static/media/grueess-di-gott-du-liebe-frueelig.82f08e2d.png";